
export default {
  routeImporter: {
    'loadRouteFile': 'Fájl importálása',
    'failedToLoadFile': 'Nem sikerült betölteni a kiválasztott fájlt. Győződjék meg arról, hogy a fájl nem sérült és az elfogadott formátumok egyikében van',
    'acceptedImportTypes': 'Elfogadott importálható fájltípusok',
    'dictDefaultMessage': 'Az importáláshoz húzzon ide egy útvonalfájlt, vagy kattintson ide',
    'dictFallbackMessage': 'A böngésző nem támogatott',
    'dictFileTooBig': 'Túl nagy a fájl',
    'dictInvalidFileType': 'Érvénytelen fájltípus',
    'dictCancelUpload': 'Feltöltés megszakítása',
    'dictUploadCanceled': 'Feltöltés megszakítva',
    'dictRemoveFile': 'Fájl eltávolítása'
  }
}
